<template>
  <div class="condition-overview-item">
    <div class="condition-overview-item__description typo-super-tiny">
      {{ description }}
    </div>
    <div class="condition-overview-item__group">
      <div
        v-if="showIndicator"
        :class="overviewIndicatorClass"
      />
      <div class="condition-overview-item__value typo-title-large">
        {{ lastInspectionDate ? lastInspectionDate : value }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { formatDate } from '@/functions/date_format_helpers';
import { computed } from 'vue';

import calculateConditionRating from '@/functions/simm/shafts/condition_rating';

import getRiskRatingLevel from '@/functions/simm/get_risk_rating_level';

const props = defineProps({
  description: { type: String, required: true },
  value: { type: Number, required: false, default: null },
  date: { type: String, required: false, default: null },
  showIndicator: { type: Boolean, required: false, default: true },
  risk: { type: Boolean, required: false, default: false }
});

const lastInspectionDate = computed(() => {
  return props.date === '-' ? props.date : formatDate(props.date);
});

const overviewIndicatorClass = computed(() => {
  const classItem = 'condition-overview-item__indicator';
  if (props.risk) return `${classItem} ${classItem}-risk--${getRiskRatingLevel(props.value)}`;
  return `${classItem} ${classItem}-condition--${calculateConditionRating(props.value)}`;
});
</script>

<style scoped lang="scss">
@import '@/stylesheets/global';
.condition-overview-item {

  &__description {
    text-transform: uppercase;
    color: transparentize(map-get($foreground-color, default), 0.5);
  }

  &__item {
    margin-bottom: bu(2);
  }

  &__group {
    align-items: center;
    display: flex;
    margin-top: bu(0.5);
  }

  &__indicator {
    background-color: map-get($background-color, lightest);
    border-radius: 100%;
    height: bu(1.5);
    margin-right: bu(1.25);
    width: bu(1.5);

    &-condition {
      @each $condition-rating, $color in $condition-rating-color {
        &--#{$condition-rating} {
          background-color: map-get($color, default);
        }
      }
    }

    &-risk {
      @each $risk-level, $color in $risk-rating-color {
        &--#{$risk-level} {
          background-color: map-get($color, default);
          color: map-get($color, tint);

          &.center {
            text-align: center;
          }

          &.margin-left {
            margin-left: bu(1);
          }

          &.margin-right {
            margin-right: bu(.5);
          }
        }
      }
    }
  }

  &__value {
    color: map-get($foreground-color, light);
    font-style: normal;
    font-weight: normal;
  }
}
</style>
